import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

import AccountFinance from "./AccountFinance";
// import AccountFinanceTest from "./AccountFinanceTest";
import ConfirmPaid from "./account/ConfirmPaid";
import ConfirmPaidLate from "./account/ConfirmPaidLate";
import Sellpac from "./SellPac";
import SellThirt from "./SellThirt";
import SellFromExcell from "./SellFromExcell";
// import DocLong from './pdf/DocLong';
// import DocSafty from './pdf/DocSafty';

import Show from "./showDetailPolicy/Show";
import Login from "./Login";
import User from "./User";
import MenuBar from "./menu/MenuBar";
import CancelPolicy from "./CancelPolicy";
import SellThirtTest from "./SellThirtTest";
import { useSelector } from "react-redux";
import SellShot from "./SellShot";
import SellShot_2 from "./SellShot_2";
import SellThirt_2 from "./SellThirt_2";
import Sellpac_2 from "./SellPac_2";
import ExportEcell_2 from "./account/Export_Ecell_2";
import SellFromExcell_2 from "./SellFromExcell";
import SellNonMotor from "./nonmotor/SellNonMotor";
import AccNonMotor from "./nonmotor/acc/AccNonMotor";

const l = process.env.REACT_APP_LINK;

export default function Home() {
  return (
    <>
      <Switch>
        <PrivateRoute path={l + "/AccountFinance"}>
          <AccountFinance />
        </PrivateRoute>

        <PrivateRoute path={l + "/AccNonMotor"}>
          <AccNonMotor/>     
        </PrivateRoute>

        <PrivateRoute path={l + "/sellpac"}>
          {/* <Sellpac /> */}
          <Sellpac_2 />
        </PrivateRoute>
  
        <PrivateRoute path={l + "/sellshot"}>
          <SellShot_2 />
        </PrivateRoute>
        <PrivateRoute path={l + "/sellshotOld"}>
          <SellShot />
        </PrivateRoute>

        <PrivateRoute path={l + "/sellnonmotor"}>
          {/* <Sellpac /> */}
          <SellNonMotor />
        </PrivateRoute>


        <PrivateRoute path={l + "/sellfromexcell"}>
          <SellFromExcell />
        </PrivateRoute>
        

        {/* <PrivateRoute path={l + "/DocLong/:no"}>
                    <DocLong />
                </PrivateRoute>
                <PrivateRoute path={l + "/docsafety/:no"}>
                    <DocSafty />
                </PrivateRoute> */}
        <Route path={l + "/showpolicy/:no"}>
          <Show />
        </Route>
        <PrivateRoute path={l + "/user"}>
          <User />
        </PrivateRoute>
        <PrivateRoute path={l + "/cancelpolicy"}>
          <CancelPolicy />
        </PrivateRoute>
        <PrivateRoute path={l + "/confirmPaid"}>
          <ConfirmPaid />
        </PrivateRoute>
        <PrivateRoute path={l + "/confirmPaidLate"}>
          <ConfirmPaidLate />
        </PrivateRoute>
        <PrivateRoute exact path={`${l}`}>
          {/* <SellThirt /> */}
          <SellThirt_2 />
        </PrivateRoute>

        {/* <PrivateRoute exact path={`${l}/`}>
                    <Accessdenied />
                </PrivateRoute> */}

        <Route path={l + "/login"}>
          <Login />
        </Route>
        <Route path={l + "/denied"}>
          <Accessdenied />
        </Route>
        <Route path={l + "/test"}>
          <SellThirtTest />
        </Route>

        <Route>
          <Notfound />
        </Route>
      </Switch>
    </>
  );
}

function PrivateRoute(props) {
  const { children, ...rest } = props;
  const user = useSelector((state) => {
    return state.user;
  });

  if (user.log) {
    if (user.level === "manager") {
      return <Route {...rest} render={() => children} />;
    } else if (user.level === "sell") {
      if (
        rest.path === l + `/user` ||
        rest.path === l + `/cancelpolicy` ||
        rest.path === l + `/confirmPaid` ||
        rest.path === l + `/confirmPaidLate` ||
        rest.path === l + `/sellfromexcell`
      ) {
        return (
          <Route
            {...rest}
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: l + "/denied",
                  state: { from: location },
                }}
              />
            )}
          />
        );
      } else {
        return <Route {...rest} render={() => children} />;
      }
    } else if (user.level === "acc") {
      if (
        rest.path === l + `/user` ||
        // rest.path === l + `/cancelpolicy` ||
        // rest.path === l + `/confirmPaid` ||
        rest.path === l + `/confirmPaidLate`
      ) {
        return (
          <Route
            {...rest}
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: l + "/denied",
                  state: { from: location },
                }}
              />
            )}
          />
        );
      } else {
        return <Route {...rest} render={() => children} />;
      }
    } else {
      return (
        <Route
          {...rest}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: l + "/denied",
                state: { from: location },
              }}
            />
          )}
        />
      );
    }
  } else {
    return (
      <Route
        {...rest}
        render={({ location }) => (
          <Redirect
            to={{
              pathname: l + "/login",
              state: { from: location },
            }}
          />
        )}
      />
    );
  }
}

function Accessdenied() {
  return (
    <div>
      <MenuBar />
      <div
        style={{
          display: "block",
          position: "absolute",
          top: "30%",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="mb-4">
            <QuestionCircleOutlined
              style={{ fontSize: 200, color: "#027c68" }}
            />
          </div>
          <h2 style={{ color: "#027c68" }}> ທ່ານບໍ່ມີສິດເຂົ້າໃຊ້ງານໜ້ານີ້</h2>
        </div>
      </div>
    </div>
  );
}

function Notfound() {
  return (
    <>
      <MenuBar />
      <div
        style={{
          display: "block",
          position: "absolute",
          top: "30%",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="mb-4">
            <QuestionCircleOutlined
              style={{ fontSize: 200, color: "#027c68" }}
            />
          </div>
          <h2 style={{ color: "#027c68" }}> ບໍ່ພົບໜ້າທີ່ທ່ານຕ້ອງການ</h2>
        </div>
      </div>
    </>
  );
}
